import DialogInOne from "src/components/DialogInOne";
import useTabTranslation from "src/hooks/useTabTranslation";
import { TRANSLATE_PREFIX } from "../../..";
import { DataGrid } from "@mui/x-data-grid";
import { dataGridDefaults } from "src/utils/constant";
import { NoRowsOverlay } from "src/components/NoRowsOverlay";
import { CustomPagination } from "src/components/CustomPagination";
import { ViewDetails } from "../types/GetAllRes";
import { useState } from "react";
import { useGenGridCol } from "src/utils/HelperComp";
import {
  displayAmount,
  findChainInfo,
  findDecimalByChainNameAndAsset,
} from "src/utils/helper";
import { RiskType } from "@wallet-manager/node-types/dist/src/postgres/const";
import { TAB_TRANSLTE_PREFIX } from "../constants";

function ViewDialog({
  isOpen,
  onClose,
  viewDetails,
}: {
  isOpen: boolean;
  onClose: () => void;
  viewDetails: ViewDetails[];
}) {
  const { t, translate } = useTabTranslation({
    featurePrefix: TRANSLATE_PREFIX,
    tabPrefix: TAB_TRANSLTE_PREFIX,
  });

  // Add paging for view details 20 items per page
  const totalCount = viewDetails.length;
  const [page, setPage] = useState(0);
  const pageSize = 20;
  const pagedViewDetails = viewDetails.slice(
    page * pageSize,
    (page + 1) * pageSize,
  );
  const rowCount = pagedViewDetails.length;

  const transformedPagedViewDetails = pagedViewDetails.map((item) => {
    const chainInfo = findChainInfo(String(item.chain_type), item.chain_id);
    const decimals = findDecimalByChainNameAndAsset(
      String(item.chain_type),
      item.chain_id,
      item.asset_name,
    );

    return {
      id: item.id,
      chainName: chainInfo?.name,
      currency: item.asset_name,
      walletDisplayName: item.dest_wallet.display_name,
      recipientAddress: item.wallet_address,
      riskType: translate(`enumRiskType.${RiskType[item.risk_type]}`),
      amount: displayAmount(item.balance, decimals),
    };
  });

  const columns = [
    useGenGridCol("chainName", t("chainName")),
    useGenGridCol("currency", t("currency")),
    useGenGridCol("walletDisplayName", t("walletDisplayName"), {
      minWidth: 150,
    }),
    useGenGridCol("recipientAddress", t("recipientAddress")),
    useGenGridCol("riskType", t("riskType")),
    useGenGridCol("amount", t("amount")),
  ];

  return (
    <DialogInOne
      title={t("view")}
      self={{
        open: isOpen,
        onClose,
      }}
      content={
        <DataGrid
          {...dataGridDefaults}
          columns={columns}
          rows={transformedPagedViewDetails}
          rowCount={rowCount}
          page={page}
          onPageChange={(newPage) => setPage(newPage)}
          components={{
            NoRowsOverlay,
            Footer: CustomPagination,
          }}
          componentsProps={{
            footer: { totalRecords: totalCount },
          }}
        />
      }
      isConfirmHidden
      onConfirm={() => {}}
      onCancel={onClose}
      maxWidth={"md"}
    />
  );
}

export default ViewDialog;
